---
title: "Bylaws of the Do Something Amateur Radio Club, Inc."
updated: 2024-01-01
adopted: 2024-01-01
---

# Bylaws of the Do Something Amateur Radio Club, Inc.

## Table of Contents

## Article I. Purpose and Mission

### Section 1. Purpose

> The purpose of the Do Something Amateur Radio Club, Inc. (DSARC, Inc.) is to support and promote the art and science of amateur radio, assist in STEM education, and foster community service through emergency communications. The corporation aims to provide education, resources, and infrastructure to amateur radio operators and to serve as a supportive resource for emergency responders and their organizations, such as Search and Rescue (SAR), Law Enforcement, Fire, EMS, Community Emergency Response Teams (CERT), and other organizations providing disaster relief and community assistance.

### Section 2. Mission

> The mission of DSARC, Inc. is to:
> - Promote and expand amateur radio as a means of education, technical skill development, and public service.
> - Facilitate STEM learning opportunities for students and the community.
> - Provide training, resources, and support for emergency communications and disaster preparedness.
> - Act as a resource for organizations providing emergency response and disaster relief, enhancing their communication and technical capabilities.
> - Support the establishment and operation of programs and clubs aligned with the corporation’s goals.

## Article II. Offices

> The principal office of the corporation in the state of Idaho shall be
> located at the address of the President of the corporation, unless otherwise determined by the board of directors. The corporation may
> have other offices, either within or outside of the state of Idaho, as
> the board of directors may determine or as the affairs of the
> corporation may require.
>
> The corporation shall maintain in the state of Idaho a registered
> office, and a registered agent whose office is identical with the
> registered office, as required by the Idaho Nonprofit Corporation Act.
> The registered office may be, but need not be, identical with the
> principal office in the state of Idaho, and the address of the
> registered office may be changed from time to time by the board of
> directors.

## Article III. Governance Structure

### Section 1. No Membership Structure

> The corporation shall not have members. The corporation shall be governed by a board of directors as outlined in these bylaws. Stakeholders may participate in programs and clubs established under the corporation but shall not have voting rights within the corporation.

### Section 2. Authority of the Board

> The board of directors shall have full authority to manage the affairs of the corporation, including oversight of programs and clubs operating under the nonprofit’s umbrella.

## Article IV. Board of Directors

### Section 1. General Powers

> The affairs of the corporation shall be managed by its board of directors. Directors need not be residents of the state of Idaho.

### Section 2. Number, Tenure, and Qualifications

> The number of directors shall be four. Each director shall hold office until the next annual meeting of the board and until their successor has been elected and qualified. Directors may also serve as officers of the corporation.

### Section 3. Officers as Board Members

> The board of directors shall include the officers of the corporation: President, Vice-President, Secretary, and Treasurer. Each officer is a voting member of the board, and their roles as officers shall coincide with their terms as directors. 

### Section 4. Chair of the Board

> The President of the corporation shall serve as the Chair of the Board. The Chair shall preside over board meetings and act as the primary representative of the board. The Chair shall continue in this role unless they resign or are removed by a majority vote of the board of directors.

### Section 5. Regular Meetings

> Regular meetings of the board of directors shall be held at least quarterly. Additional meetings may be scheduled as needed.

### Section 6. Special Meetings

> Special meetings of the board of directors may be called by the President or any two directors.

### Section 7. Quorum

> A majority of the board of directors shall constitute a quorum for the transaction of business. Decisions shall be made by a majority vote of the directors present, unless otherwise specified in these bylaws.

### Section 8. Compensation

> Directors shall not receive any stated salaries for their services but may be reimbursed for reasonable expenses incurred in the performance of their duties.

### Section 9. Informal Action by Directors

> Any action required or permitted to be taken at a meeting of the board of directors may be taken without a meeting if all directors consent in writing.

## Article V. Officers

### Section 1. Officers

> The officers of the corporation shall be a President, a Vice-President, a Secretary, and a Treasurer. Officers shall be elected from among the board members and shall retain voting rights as directors.

### Section 2. Election and Term of Office

> Officers shall be elected annually by the board of directors at the first meeting of the board following the start of the fiscal year. Each officer shall serve until their successor is elected and qualified.

### Section 3. Removal and Vacancies

> Any officer may be removed by the board whenever it is in the best interest of the corporation. Vacancies may be filled by the board for the unexpired term.

## Article VI. Programs and Clubs

### Section 1. Establishment

> The board of directors may authorize the creation of programs and clubs to further the corporation’s mission. Each program or club shall operate under the authority of the board and in alignment with the corporation’s bylaws and policies.

### Section 2. Governance

> Programs and clubs shall have their own bylaws or charters, subject to approval by the board of directors. These documents shall outline the purpose, membership, and leadership structure of the program or club.

### Section 3. Membership and Leadership

> Programs and clubs may have members who participate in activities and vote on program-specific matters. Each program or club shall elect its own officers to manage day-to-day operations, subject to oversight by the board of directors.

### Section 4. Financial Management

> All funds raised or collected by programs and clubs shall be deposited into the corporation’s general fund. The board may allocate budgets to programs and clubs based on their needs and approved plans. Donations with specific purposes shall be earmarked for those purposes.

### Section 5. Reporting

> Programs and clubs shall submit regular reports to the board of directors, including financial summaries, membership updates, and activity reports.

## Article VII. Contracts, Checks, Deposits, and Funds

### Section 1. Contracts

> The board of directors may authorize any officer or agent to enter into contracts or execute instruments on behalf of the corporation.

### Section 2. Checks, Drafts, etc.

> All checks, drafts, or orders for payment shall be signed by officers or agents designated by the board.

### Section 3. Deposits

> All funds shall be deposited in financial institutions selected by the board.

### Section 4. Gifts

> The board may accept contributions, gifts, bequests, or devises for any purpose aligned with the corporation’s mission.

## Article VIII. Amendments to Bylaws

> These bylaws may be amended by a majority vote of the board of directors at any regular or special meeting, provided notice of the proposed amendment is given at least seven days in advance.
